import { createSelector } from '@ngrx/store';
import { getSelfCustomer } from '../customers/customers.selectors';
import { getIsFamily } from '../organisations/organisations.selectors';

export const canUseLists = createSelector(
  getSelfCustomer,
  getIsFamily,
  (selfCustomer, isFamily) => {
    return !isFamily && !selfCustomer;
  }
);
